module.exports = __webpack_public_path__ + "img/image130.f8b21451.png";